export default __webpack_public_path__ + "static/media/mobile-phones-480.9850cff0.png";